var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { "background-color": "#f0f0f0" } },
    [
      _c(
        "el-header",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: ![
                "/tpl/personSet",
                "/tpl/general",
                "/tpl/accountInfo",
                "/tpl/costStatistics",
                "/tpl/signers",
                "/tpl/corpSet"
              ].includes(_vm.$route.path),
              expression:
                "!['/tpl/personSet', '/tpl/general', '/tpl/accountInfo', '/tpl/costStatistics', '/tpl/signers', '/tpl/corpSet'].includes($route.path)"
            }
          ],
          class: {
            "my-el-header": true,
            homePage: _vm.isInDingTalk ? false : _vm.useThisHeader
          }
        },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "jzq-logo", attrs: { span: 3 } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.isInDingTalk
                              ? "/viewIndex"
                              : _vm.globalConfig.domain.junziqanIndex
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: "/images/logo/jzq-logo.png", alt: "" }
                          })
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-col",
                    { style: { display: "block" }, attrs: { span: 15 } },
                    [
                      _c("nav", [
                        _vm.currentAuthUser.userType == 0 ||
                        _vm.currentAuthUser.userType == 1
                          ? _c("ul", [
                              _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "item",
                                      attrs: { to: "/viewIndex" }
                                    },
                                    [_vm._v("首页")]
                                  )
                                ],
                                1
                              ),
                              _c("li", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "item",
                                    on: {
                                      click: function($event) {
                                        return _vm.turnFilePage({
                                          path: "/signInfo/signList",
                                          query: { signStatus: 2 }
                                        })
                                      }
                                    }
                                  },
                                  [_vm._v("文件管理")]
                                )
                              ]),
                              _c(
                                "li",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: { click: _vm.pageChangeFn }
                                },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("司法服务")
                                  ])
                                ]
                              ),
                              _vm.$store.getters.currentAuthUser
                                .merchantFlag === 1
                                ? _c(
                                    "li",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: { click: _vm.APIabutment }
                                    },
                                    [
                                      _c("div", { staticClass: "item" }, [
                                        _vm._v("API对接")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.isInDingTalk &&
                              (_vm.accountInfoVO.userType === 1 ||
                                _vm.bindCorpUsersList.length === 1)
                                ? _c("li", { staticClass: "active" }, [
                                    _c("span", { staticClass: "item" }, [
                                      _vm._v("业务定制系统")
                                    ])
                                  ])
                                : !_vm.isInDingTalk &&
                                  _vm.bindCorpUsersList.length > 1
                                ? _c(
                                    "li",
                                    { staticClass: "active" },
                                    [
                                      _c(
                                        "el-dropdown",
                                        {
                                          on: { command: _vm.handleCommandFn }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-dropdown-link item"
                                            },
                                            [_vm._v("业务定制系统")]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown"
                                            },
                                            _vm._l(
                                              _vm.bindCorpUsersList,
                                              function(item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          item.userStemFrom !==
                                                          -16,
                                                        expression:
                                                          "item.userStemFrom !== -16"
                                                      }
                                                    ],
                                                    key: index,
                                                    attrs: { command: item }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.corpName)
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm.currentAuthUser.superFlag == 0 ||
                            _vm.currentAuthUser.superFlag == 1
                          ? _c("ul", [
                              _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "item",
                                      attrs: { to: "/viewIndex" }
                                    },
                                    [_vm._v("首页")]
                                  )
                                ],
                                1
                              ),
                              _c("li", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "item",
                                    on: {
                                      click: function($event) {
                                        return _vm.turnFilePage({
                                          path: "/corp/signInfo/signList",
                                          query: { signStatus: 4 }
                                        })
                                      }
                                    }
                                  },
                                  [_vm._v("文件管理")]
                                )
                              ]),
                              _c(
                                "li",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: { click: _vm.pageChangeFn }
                                },
                                [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("司法服务")
                                  ])
                                ]
                              ),
                              !_vm.isInDingTalk &&
                              (_vm.accountInfoVO.userType === 1 ||
                                _vm.bindCorpUsersList.length === 1)
                                ? _c("li", { staticClass: "active" }, [
                                    _c("span", { staticClass: "item" }, [
                                      _vm._v("业务定制系统")
                                    ])
                                  ])
                                : !_vm.isInDingTalk &&
                                  _vm.bindCorpUsersList.length > 1
                                ? _c(
                                    "li",
                                    { staticClass: "active" },
                                    [
                                      _c(
                                        "el-dropdown",
                                        {
                                          on: { command: _vm.handleCommandFn }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-dropdown-link item"
                                            },
                                            [_vm._v("业务定制系统")]
                                          ),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              slot: "dropdown"
                                            },
                                            _vm._l(
                                              _vm.bindCorpUsersList,
                                              function(item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          item.userStemFrom !==
                                                          -16,
                                                        expression:
                                                          "item.userStemFrom !== -16"
                                                      }
                                                    ],
                                                    key: index,
                                                    attrs: { command: item }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.corpName)
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "padding-left": "20px",
                        "box-sizing": "border-box"
                      },
                      attrs: { span: 6 }
                    },
                    [
                      !_vm.isInDingTalk
                        ? _c(
                            "el-row",
                            [
                              _c("user-header", {
                                staticStyle: { float: "right" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "y-header", staticStyle: { height: "60px" } }),
      _c("div", { staticClass: "main_width" }, [_c("nuxt")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-897b5f1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897b5f1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/headandfullpage.vue
// module id = nsit
// module chunks = 137